<template>
  <div id="verify-tree-grid" class="grid-view">
    <div class="main-content">
      <div slot="operations">
        <div>
          <el-form
            label-width="100px"
            label-position="left"
            style="margin-right:10px;padding-top: 10px"
          >
            <el-row>
              <!--   第一列          -->
              <el-col :span="6">
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.FileNo')"
                  prop="fileNo"
                >
                  <el-input v-model="query.fileNo" no="1" />
                </el-form-item>
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.BusinessNo')"
                  prop="jobNo"
                >
                  <el-input v-model="query.jobNo" no="2" />
                </el-form-item>
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.BookingAgent')"
                  prop="bookingAgent"
                >
                  <cargo-advance-select
                    no="3"
                    filterable
                    :select-type="selectTypeNames.basic_data_Company"
                    :method-params="{bookingAgent:true}"
                    callback-method-type="value"
                    :placeholder="' '"
                    :default-value="query.bookingAgent||''"
                    :callback-params="{key:'bookingAgent'}"
                    @parentCallBack="setQuerySelectValue"
                  />
                </el-form-item>
                <el-form-item
                  class="query-input-spacing"
                  :label="this.$t('SeaExport.PortOfDestination')"
                  prop="destinationPort"
                >
                  <cargo-advance-select
                    ref="pod"
                    no="4"
                    :select-type="query.portType==='AE'?selectTypeNames.basic_data_Airport:selectTypeNames.basic_data_Seaport"
                    filterable
                    :placeholder="' '"
                    :default-value="query.destinationPort"
                    tag-name="englishName"
                    @parentCallBack="p=>query.destinationPort=p.code"
                  />
                </el-form-item>
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('Clearing.HouseWaybillNumber')"
                  prop="jobHbl"
                >
                  <el-input v-model="query.jobHbl" no="5" />
                </el-form-item>
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.SalesDepartment')"
                >
                  <cargo-department-select
                    no="salesDepartment"
                    :office-id="$store.getters.currentOfficeId"
                    :department-id="Number(query.salesDept)"

                    @change="p=>{query.salesDept=p.value}"
                  />
                </el-form-item>
              </el-col>
              <!--   第二列          -->
              <el-col :span="6">
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.Customer')"
                  prop="customerId"
                >
                  <cargo-company-select
                    no="8"
                    class="shipper-selector"
                    popper-class="shipper-selector-popper"
                    :method-params="{customer:true}"
                    :default-value="query.customerId||''"
                    :placeholder="' '"
                    style="flex: 1;"
                    @change="p=>{query.customerId=p.value}"
                  />
                </el-form-item>
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.CustomsBroker')"
                  prop="customsBroker"
                >
                  <cargo-company-select
                    no="9"
                    :method-params="{customsBroker:true,active:true}"
                    :default-value="query.customsBroker||''"
                    :placeholder="' '"
                    style="width:250px;"
                    @change="p=>{query.customsBroker=p.value}"
                  />
                </el-form-item>
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.OperatingCompany')"
                  prop="companyCName"
                >
                  <el-input v-model="query.companyCName" no="10" />
                </el-form-item>
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('CargoMsg.Cargo_TypeOfPort')"
                  prop="portType"
                >
                  <el-radio-group v-model="query.portType" no="11">
                    <el-form-item>
                      <el-radio label="SE" style="float:left">{{ $t('CargoMsg.Cargo_OceanFreight') }}</el-radio>
                      <el-radio label="AE" style="float:left">{{ $t('CargoMsg.Cargo_Air') }}</el-radio>
                    </el-form-item>
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.SoNo')"
                  prop="soNo"
                >
                  <el-input v-model="query.soNo" no="12" />
                </el-form-item>
                <div>
                  <el-button no="6" type="primary" @click="queryHandler">{{ $t('CargoMsg.Cargo_Search') }}</el-button>
                  <el-button no="7" type="primary" @click="clearPage">{{ $t('CargoMsg.Cargo_ResetFilter') }}</el-button>
                </div>
              </el-col>
              <!--   第三列          -->
              <el-col :span="6">
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.BusinessType')"
                  prop="jobLobs"
                >
                  <cargo-advance-select
                    no="13"
                    :select-type="selectTypeNames.local_cache_SystemConstants$LOBS"
                    filterable
                    :placeholder="' '"
                    callback-method-type="value"
                    :multiple="true"
                    :default-multiple-value="query.jobLobs"
                    @parentCallBack="value=>query.jobLobs=[...value]"
                  />
                </el-form-item>
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.Status')"
                  prop="status"
                >
                  <cargo-advance-select
                    no="14"
                    :select-type="selectTypeNames.local_cache_SystemConstants$FILE_STATUS3"
                    filterable
                    :placeholder="' '"
                    callback-method-type="value"
                    :multiple="true"
                    :default-multiple-value="query.status"
                    @parentCallBack="value=>query.status=[...value]"
                  />
                </el-form-item>
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.Vessel')"
                  prop="vessel"
                >
                  <cargo-advance-select
                    no="15"
                    filterable
                    clearable
                    :select-type="selectTypeNames.basic_data_Vessel"
                    tag-name="englishName"
                    tag-value="englishName"
                    :placeholder="' '"
                    :default-value="query.vessel"
                    @parentCallBack="p=>{query.vessel=p.value}"
                  />
                </el-form-item>
                <div style="padding-bottom: 5px;margin-right: 10px;display: flex">
                  <el-select
                    v-model="query.timeType"
                    no="16"
                    style="min-width: 100px"
                    @change="setQuerySelectValue"
                  >
                    <el-option
                      v-for="(item,index) in timeTypes"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                  <el-date-picker
                    v-model="query.timeStart"
                    no="17"
                    style="width: 100%"
                    type="date"
                    value-format="yyyy-MM-dd"
                  />
                  <span style="padding-top: 5px">{{ $t('CargoMsg.Cargo_To') }}</span>
                  <el-date-picker
                    v-model="query.timeEnd"
                    no="18"
                    style="width: 100%"
                    type="date"
                    value-format="yyyy-MM-dd"
                  />
                </div>
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.ShippingCompany')"
                  prop="jobCarrierId"
                >
                  <cargo-company-select
                    no="19"
                    :placeholder="' '"
                    :method-params="{seaCmp:true,active:true}"
                    :default-value="query.jobCarrierId||''"
                    @change="p=>{query.jobCarrierId=p.value}"
                  />
                </el-form-item>
              </el-col>
              <!--  第四列          -->
              <el-col :span="6">
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.FileType')"
                  prop="fileTypes"
                >
                  <cargo-advance-select
                    no="20"
                    filterable
                    :multiple="true"
                    :placeholder="' '"
                    :data-filter-function="dataFilterFunc"
                    callback-method-type="value"
                    :select-type="selectTypeNames.basic_data_TransmitFileType"
                    :default-multiple-value="query.fileTypes"
                    :tag-value="'name'"
                    @parentCallBack="value=>query.fileTypes=[...value]"
                  />
                </el-form-item>
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.Mbl2')"
                  prop="jobMbl"
                >
                  <el-input v-model="query.jobMbl" no="21" />
                </el-form-item>
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.Voyage')"
                  prop="voyageFlight"
                >
                  <el-input v-model="query.voyageFlight" no="22" />
                </el-form-item>
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.Operation')"
                  prop="op"
                >
                  <cargo-user-select
                    no="23"
                    :method-params="{category:'role',shape:'op'}"
                    :default-value="query.op"
                    :placeholder="' '"
                    @change="p=>{query.op=p.value}"
                  />
                </el-form-item>
                <el-form-item
                  class="query-input-spacing"
                  :label="$t('SeaExport.Sales')"
                  prop="sales"
                >
                  <cargo-user-select
                    no="23"
                    :method-params="{category:'role',shape:'sales'}"
                    :default-value="query.sales"
                    :placeholder="' '"
                    @change="p=>{query.sales=p.value}"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <div style="display:flex;height:65%">
        <div style="display: flex;flex-direction: column;width: 100%;" class="section">
          <cargo-ag-grid
            config-module="950001"
            :locale-text-func="_i18nGridLocalText"
            :grid-options="businessList.gridOptions"
            :column-defs="businessList.columnDefs"
            :row-data="businessList.rowData"
            :grid-params.sync="businessList.gridParams"
            class="ag-theme-balham"
            style="width: 100%;height:60%"
            @gridReady="onGridReady"
          />
          <div class="pagination-wrapper">
            <cargo-pagination
              config-module="9500003"
              :total="businessList.total"
              :page.sync="businessList.filter.pageNum"
              :limit.sync="businessList.filter.pageSize"
              @pagination="toQueryByPage"
            />
          </div>
        </div>
      </div>

      <div class="section">
        <div>
          <div>
            <!--取回-->
            <el-button v-show="$checkPermission(['button_CRFileBack_file'])" no="24" :disabled="!opButton.batchBackBtn" type="primary" @click="onBack">{{ $t('SeaExport.Back') }}</el-button>
            <!--撤销取回-->
            <el-button v-show="$checkPermission(['button_CRFileBack_file'])" no="25" :disabled="!opButton.batchCancelBackBtn" type="primary" @click="onCancelBack">{{ $t('Clearing.RevokeFetch') }}</el-button>
            <!--二次送出-->
            <el-button :disabled="!opButton.secondSend" type="primary" @click="secondSendHandler">{{ $t('CargoMsg.Cargo_2NdDispatch') }}</el-button>
            <!--修改备注-->
            <el-button no="26" :disabled="!opButton.editBtn" type="primary" @click="editRemarkHandler">{{ $t('CargoMsg.Cargo_EditRemarks') }}</el-button>
            <!--删除-->
            <el-button no="27" :disabled="!opButton.delBtn" type="primary" @click="deleteHandler">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
            <!--清单打印-->
            <el-button no="28" :disabled="!opButton.batchPrintBtn" type="primary" @click="onPrint">{{ $t('CargoMsg.Cargo_PrintList') }}</el-button>
            <!--送出-->
            <el-button no="29" :disabled="!opButton.batchSendBtn" type="primary" @click="onSend">{{ $t('CargoMsg.Cargo_Send2') }}</el-button>
          </div>
          <el-form :inline="true" label-width="65px" label-position="left" style="padding-top:5px">
            <el-form-item :label="this.$t('SeaExport.OperatingCompany')" class="custom">
              <el-input v-model="businessList.selectedData.companyCName" no="30" :readonly="true" style="width:160px" :disabled="true" />
            </el-form-item>
            <el-form-item :label="this.$t('CargoMsg.Cargo_VesselAndVoyage')" class="custom">
              <el-input no="31" :value="vesselAndVoyage()" :readonly="true" style="width:160px" :disabled="true" />
            </el-form-item>
            <el-form-item :label="this.$t('SeaExport.DepartureTime')" class="custom">
              <el-date-picker
                v-model="businessList.selectedData.etd"
                no="32"
                :readonly="true"
                :disabled="true"
                type="date"
                style="width:160px"
                clearable
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TenBitCode')" class="custom">
              <el-input v-model="businessList.selectedData.tenDigitCode" no="33" :readonly="true" style="width:160px" :disabled="true" />
            </el-form-item>
          </el-form>
          <el-form :inline="true" label-width="65px" label-position="left" style="padding-top:5px">
            <el-form-item :label="this.$t('SeaExport.Customer')" class="custom">
              <cargo-company-select
                no="34"
                :readonly="true"
                :custom-style="'width:160px'"
                :disabled="true"
                :placeholder="' '"
                popper-class="shipper-selector-popper"
                :method-params="{customer:true}"
                :default-value="businessList.selectedData.customerId||''"
              />
            </el-form-item>
            <el-form-item :label="'MBL'" class="custom">
              <el-input v-model="businessList.selectedData.mbl" no="35" :readonly="true" style="width:160px" :disabled="true" />
            </el-form-item>
            <el-form-item :label="this.$t('SeaExport.Operation')" class="custom">
              <cargo-advance-select
                no="36"
                :readonly="true"
                :disabled="true"
                style="width:160px"
                filterable
                :placeholder="' '"
                :select-type="selectTypeNames.basic_data_User"
                callback-method-type="value"
                :default-value="businessList.selectedData.op===0?'':businessList.selectedData.op"
                :callback-params="{key:'op'}"
                @parentCallBack="setQuerySelectValue"
              />
            </el-form-item>
            <el-form-item :label="this.$t('SeaExport.CustomsBroker')" class="custom">
              <cargo-company-select
                no="37"
                :disabled="true"
                :placeholder="' '"
                :method-params="{customsBroker:true,seaExport:true,active:true}"
                :default-value="businessList.selectedData.customsBroker||''"
                :custom-style="'width:160px;'"
                @change="p=>{businessList.selectedData.customsBroker=p.value}"
              />
            </el-form-item>
          </el-form>
          <el-form :inline="true" label-width="65px" label-position="left">
            <el-form-item :label="$t('SeaExport.Remarks')" class="custom">
              <el-input
                v-model="businessList.selectedData.remark"
                no="38"
                type="textarea"
                :rows="3"
                :readonly="true"
                style="width:1000px"
                :disabled="true"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.Remarks'),businessList.selectedData.remark,val=>{businessList.selectedData.remark=val})"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>

    </div>

    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-input v-model="advanceTextDialog.value" type="textarea" rows="10" no="39" />
      <span slot="footer">
        <el-button type="primary" no="40">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="41"
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>

    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />

    <!--    送出-->
    <dc-send-out-window
      ref="dcSendOut"
      :send-out-dialog="sendOutDialog"
      :visible="sendOutDialog.visible"
      :job="job"
      :selected-files="selectedFiles"
      @dcSendOutVisible="sendOutDialog.visible=false"
      @successHandler="backSuccessHandler"
    />
    <!-- 文件编辑弹框 -->
    <file-dialog ref="fileDialog" :visible.sync="editDialog.visible" :is-remark-only="editDialog.isRemarkOnly" :selected-file="businessList.selectedData" :job="job" @successHandler="successHandler" @backSuccessHandler="backSuccessHandler" />
    <!--    取回-->
    <dc-take-back-window
      ref="dcTakeBack"
      :take-back-dialog="takeBackDialog"
      :visible="takeBackDialog.visible"
      :job="job"
      :selected-files="selectedFiles"
      @successHandler="backSuccessHandler"
    />
  </div>
</template>

<script>
import CargoGridShowBigContent from '@/components/Cargo/grid/cargoGridShowBigContent'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cacheName, cache } from '@/utils/cacheManager'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import CargoDateTimePicker from '@/components/Cargo/Common/CargoDateTimePicker'
import { stateQueryClickHandler } from '@/class/cargo/model/utils/file'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import {
  batchBackFileHandler,
  delFile,
  queryDcListHandler,
  doSecondSendHandler
} from '@/api/seaExport/file'
import ColumnUtils from '@/utils/ColumnUtils'
import dcSendOutWindow from '@/views/cargo/v0/Clearing/components/DocumentCirculation/dcSendOutWindow'
import DcTakeBackWindow from '@/views/cargo/v0/Clearing/components/DocumentCirculation/dcTakeBackWindow'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { AirImportJob } from '@/class/model/booking/AirImportJob'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import fileDialog from '@/components/Cargo/Job/fileDialog'
import { getCacheListByKey, getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { Company } from '@/class/model/mdm/Company'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect.vue'

export default {
  name: 'SearchMarkDetail',
  components: {
    cargoDepartmentSelect,
    DcTakeBackWindow,
    CargoAdvanceSelect,
    cargoUserSelect,
    CargoDateTimePicker,
    dcSendOutWindow,
    fileDialog,
    stateQueryClickHandler,
    cargoCompanySelect,
    cargoTemplateSelectorDialog,
    CargoGridShowBigContent
  },
  props: {
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      fileTypeList: getCacheListByKey(basicCacheKeys.basic_data_TransmitFileType),
      query: {
        fileNo: '',
        jobNo: '',
        bookingAgent: 0,
        destinationPort: '',
        jobHbl: '',
        customerId: 0,
        customsBroker: 0,
        companyCName: '',
        portType: 'SE',
        soNo: '',
        jobLobs: ['SE', 'SI', 'AE', 'AI', 'RE'],
        status: [],
        vessel: '',
        sales: null,
        salesDept: null,
        timeType: 1,
        timeStart: null,
        timeEnd: null,
        fileTypes: [],
        jobMbl: '',
        voyageFlight: '',
        jobCarrierId: 0
      },
      timeTypes: [
        { label: this.$t('Clearing.CreationDate'), value: 0 },
        { label: this.$t('Clearing.SentOutDate'), value: 1 },
        { label: this.$t('Clearing.FetchDate'), value: 2 },
        { label: this.$t('Clearing.ReturnDate'), value: 3 },
        { label: this.$t('Clearing.DeclarationDate'), value: 4 },
        { label: this.$t('Clearing.SailingDate'), value: 5 }
      ],
      businessList: {
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
          suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
          // 选中 勾选框或者其他列 都会触发
          onCellFocused: (event) => {
            this.onGridCellFocused(event)
          },
          // 行点击事件
          onRowClicked: this.onRowClickedByBL,
          // 行勾选事件
          onRowSelected: this.onRowSelected,
          defaultColDef: {
            resizable: true
          },
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          {
            headerName: '', width: 30, checkboxSelection: true,
            suppressSorting: true, suppressMenu: true, suppressSizeToFit: true, suppressResize: true,
            headerCheckboxSelection: true
          },
          { headerName: this.$t('SeaExport.BusinessNo'), field: 'jobNo', width: 180, colId: 'jobNo' },
          { headerName: this.$t('SeaExport.Mbl2'), field: 'mbl', width: 180, colId: 'mbl' },
          { headerName: this.$t('SeaExport.FileType'), field: 'fileType', width: 180, colId: 'fileType',
            cellRenderer: params => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_TransmitFileType, 'code', params.value, 'name')
            }
          },
          { headerName: this.$t('SeaExport.FileNo'), field: 'fileNo', width: 180, colId: 'fileNo' },
          { headerName: this.$t('SeaExport.SendingDate'), field: 'sendDate', width: 180, colId: 'sendDate',
            cellRenderer: params => {
              return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
            }
          },
          { headerName: this.$t('SeaExport.ReceivingDate'), field: 'backDate', width: 180, colId: 'backDate',
            cellRenderer: params => {
              return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
            }
          },
          { headerName: this.$t('SeaExport.Receiver'), field: 'backUser', width: 180, colId: 'backUser',
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          { headerName: this.$t('SeaExport.ReturnDate'), field: 'returnDate', width: 180, colId: 'returnDate',
            cellRenderer: params => {
              return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
            }
          },
          { headerName: this.$t('SeaExport.ReturnExpressNumber'), field: 'returnExpressNo', width: 180, colId: 'returnExpressNo' },
          { headerName: this.$t('SeaExport.DateOfDeclaration'), field: 'declareDate', width: 180, colId: 'declareDate',
            cellRenderer: params => {
              return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
            }
          },
          { headerName: this.$t('SeaExport.Status'), field: 'state', width: 180, colId: 'state',
            cellRenderer: params => {
              return ColumnUtils.fileStatusLabelFunc(params.value)
            }
          },
          { headerName: this.$t('CargoMsg.Cargo_CourierOrderNo'), field: 'sendExpressNo', width: 180, colId: 'sendExpressNo' },
          { headerName: this.$t('CargoMsg.Cargo_2NdDispatch'), field: 'second', width: 180, colId: 'second',
            cellRenderer: params => {
              return params.value ? this.$t('Clearing.Yes') : this.$t('Clearing.No')
            }
          },
          { headerName: this.$t('CargoMsg.Cargo_2NdDispatchTime'), field: 'secondSendDate', width: 180, colId: 'secondSendDate',
            cellRenderer: params => {
              return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
            }
          },
          { headerName: this.$t('SeaExport.DepartureTime'), field: 'etd', width: 180, colId: 'etd',
            cellRenderer: params => {
              return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
            }
          },
          { headerName: this.$t('SeaExport.OperatingCompany'), field: 'companyCName', width: 180, colId: 'companyCName' },
          { headerName: this.$t('SeaExport.Customer'), field: 'customerId', width: 180, colId: 'customerId',
            cellRenderer: params => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          { headerName: this.$t('SeaExport.CustomsBroker'), field: 'customsBroker', width: 180, colId: 'customsBroker',
            cellRenderer: params => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          { headerName: this.$t('SeaExport.DateOfCreation'), field: 'dateCreated', width: 180, colId: 'dateCreated',
            cellRenderer: params => {
              return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
            }
          },
          { headerName: this.$t('SeaExport.Creator'), field: 'inputBy', width: 180, colId: 'inputBy',
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          { headerName: this.$t('CargoMsg.Cargo_OperatorOfWithdrawal'), field: 'returnPerson', width: 180, colId: 'returnPerson',
            cellRenderer: params => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          { headerName: this.$t('SeaExport.TakeByCustomsBroker'), field: 'tax', width: 180, colId: 'tax',
            cellRenderer: params => {
              return params.value ? this.$t('Clearing.Yes') : this.$t('Clearing.No')
            }
          },
          { headerName: this.$t('SeaExport.Operation'), field: 'op', width: 180, colId: 'op',
            cellRenderer: params => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          { headerName: this.$t('SeaExport.Sales'), field: 'salesId', width: 180, colId: 'salesId', hide: true,
            cellRenderer: params => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          { headerName: this.$t('SeaExport.SalesDepartment'), field: 'salesDept', width: 180, colId: 'salesDept', hide: true,
            cellRenderer: params => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', params.value, 'chineseName')
            }
          },
          { headerName: this.$t('SeaExport.SalesCompany'), field: 'salesOffice', width: 220, colId: 'salesOffice', hide: true,
            cellRenderer: params => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'chineseName')
            }
          },
          { headerName: this.$t('SeaExport.BookingAgent'), field: 'bookingAgent', width: 180, colId: 'bookingAgent',
            cellRenderer: params => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          { headerName: this.$t('SeaExport.Vessel'), field: 'vessel', width: 180, colId: 'vessel' },
          { headerName: this.$t('SeaExport.Voyage'), field: 'voyageFlight', width: 180, colId: 'voyageFlight' },
          { headerName: this.$t('SeaExport.PortOfDestination'), field: 'destinationPortCode', width: 180, colId: 'destinationPortCode',
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'code')
            }
          },
          { headerName: this.$t('SeaExport.Quantity'), field: 'quantityActual', width: 180, colId: 'quantityActual',
            cellRenderer: (params) => {
              return ColumnUtils.formatNumber(params.value, 0, true)
            }
          },
          { headerName: this.$t('SeaExport.Weight2'), field: 'weightActual', width: 180, colId: 'weightActual',
            cellRenderer: (params) => {
              return ColumnUtils.formatNumber(params.value, 2, true)
            }
          }
        ],
        rowData: [],
        gridParams: {},
        total: 0,
        filter: {
          pageNum: 1,
          pageSize: 10,
          branchId: 0
        },
        selectedData: {}
      },
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null
      },
      editDialog: {
        visible: false,
        isRemarkOnly: false
      },
      // 文件操作按钮
      opButton: {
        batchBackBtn: false,
        batchCancelBackBtn: false,
        secondSend: false,
        editBtn: false,
        delBtn: false,
        batchPrintBtn: false,
        batchSendBtn: false
      },
      // 送出弹框
      sendOutDialog: {
        visible: false,
        sendType: 1,
        customerType: 1,
        printFlag: false,
        formData: {
          receiveCompany: '',
          receivePerson: '',
          receiveAddress: '',
          receiveTel: '',
          expressNo: ''
        }
      },
      // 取回弹框
      takeBackDialog: {
        visible: false,
        dataLabel: '',
        dataLabelTitle: '',
        backDate: '',
        startDate: '',
        selectableRange: ''
      },
      job: {
        lob: '',
        soNo: '',
        uuid: '',
        containerLoadType: '',
        bookingAgent: 0,
        customerId: 0,
        customerContact: '',
        opOffice: 0,
        mbl: '',
        customsBroker: 0
      },
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        cxt: new SeaExportJob(),
        category: 'FileList',
        data: {}
      },
      gridApi: null,
      selectedFiles: [],
      cbAutoRefresh: true
    }
  },
  computed: {

  },
  async created() {
    await cache.load(cacheName.OFFICE, cacheName.CONFIG)
    this.office = cache.office
  },
  beforeMount() {

  },
  beforeDestroy() {

  },
  methods: {
    onGridReady(p) {
      this.gridApi = p.api
    },
    clearPage() {
      this.query = PriceUtils.resetFilter(this.query)
      this.query.portType = 'SE'
      this.query.timeType = 1
    },
    queryHandler() {
      this.businessList.filter.pageNum = 1
      this.toQueryByPage()
    },
    setQuerySelectValue(obj) {
      this.query[obj.key] = obj.value
    },
    // 参考老cargo去除中文重复
    dataFilterFunc(item) {
      const typeMap = {}
      for (const tUuid of this.fileTypeList) {
        typeMap[tUuid.name] = tUuid.uuid
      }
      const nowType = typeMap[item.name]
      if (nowType && nowType === item.uuid) {
        return true
      }
      return false
    },
    showAdvanceTextDialog(title, value, successCallback) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.visible = true
    },
    // 查询
    toQueryByPage() {
      Object.keys(this.query).forEach((key) => {
        this.businessList.filter[key] = this.query[key]
      })
      this.businessList.filter.pageNum = this.businessList.filter.pageNum
      this.businessList.filter.pageSize = this.businessList.filter.pageSize
      this.businessList.filter.branchId = this.$store.getters.currentOfficeId
      this.businessList.selectedData = {}
      this.checkButtonState()
      this.loading = getLoading()
      queryDcListHandler(this.businessList.filter).then(res => this.handleQueryData(res)).catch((err) => {
        this.$message.error(err)
        this.loading.close()
      })
    },
    // 查询返回结果[公用]
    handleQueryData(res) {
      this.businessList.rowData = res.data.list
      this.businessList.filter.pageNum = res.data.pageNum
      this.businessList.filter.pageSize = res.data.pageSize
      this.businessList.total = Number(res.data.total)
      // 初始化选中业务
      this.businessList.selectedData = {}
      this.selectedFiles = []
      this.gridApi.clearFocusedCell()
      this.checkButtonState()
      this.loading.close()
    },
    vesselAndVoyage() {
      const data = this.businessList.selectedData
      let value = ''
      if (data.vessel) {
        value = data.vessel
      }
      if (data.vessel && data.voyageFlight) {
        value += '/'
      }
      if (data.voyageFlight) {
        value += data.voyageFlight
      }
      return value
    },
    // 行点击触发事件
    onRowClickedByBL(event) {
      if (!event) return
      this.businessList.selectedData = {}
      const node = event.data
      if (node) {
        this.businessList.selectedData = node
        Object.keys(this.job).forEach((key) => {
          this.job[key] = node[key]
          this.job.uuid = node['jobUuid']
        })
        this.checkButtonState()
      }
    },
    onRowSelected(event) {
      if (!event || !event.data) return
      if (event.node.isSelected()) {
        this.selectedFiles.push(event.data)
      } else {
        this.selectedFiles = this.gridApi.getSelectedRows()
      }
      this.onRowClickedByBL(event)
    },
    // 选中 勾选框或者其他列 都会触发[获取选中行]
    onGridCellFocused(event) {
      if (!event) return
      this.businessList.selectedData = {}
      if (this.gridApi) {
        this.gridApi.forEachNode(node => {
          if (node && node.rowIndex === event.rowIndex && node.data) {
            const file = node.data
            if (file.uuid) {
              this.businessList.selectedData = file
              Object.keys(this.job).forEach((key) => {
                this.job[key] = node[key]
                this.job.uuid = node['jobUuid']
              })
              this.checkButtonState()
            }
          }
        })
      }
    },
    // 检查按钮状态
    checkButtonState() {
      if (this.businessList.selectedData && this.businessList.selectedData.uuid) {
        const selectedFile = this.businessList.selectedData
        this.opButton.secondSend = (!selectedFile.second && selectedFile.state === 2 || selectedFile.state === 1)
        this.opButton.delBtn = selectedFile.state === 0
        this.opButton.editBtn = true
      } else {
        this.opButton.secondSend = false
        this.opButton.delBtn = false
        this.opButton.editBtn = false
      }
      this.opButton.batchSendBtn = this.opButton.batchPrintBtn = this.opButton.batchBackBtn = this.opButton.batchCancelBackBtn = false
      if (this.selectedFiles && this.selectedFiles.length > 0) {
        this.opButton.batchSendBtn = this.selectedFiles.length > 0
        this.opButton.batchBackBtn = this.selectedFiles.length > 0
        this.opButton.batchCancelBackBtn = this.selectedFiles.length > 0
        this.opButton.batchPrintBtn = true
      }
    },
    // =============================送出 star==================================
    onSend() {
      this.sendOutDialog.visible = true
      this.sendOutDialog.sendType = 0
      this.sendOutDialog.customerType = this.sendOutDialog.sendType
      this.clearForm()
      this.setByCompanyId(this.job.bookingAgent)
      this.sendOutDialog.formData.expressNo = this.businessList.selectedData.sendExpressNo
    },
    clearForm() {
      this.sendOutDialog.formData.receiveCompany = ''
      this.sendOutDialog.formData.receiveAddress = ''
      this.sendOutDialog.formData.receivePerson = ''
      this.sendOutDialog.formData.receiveTel = ''
      this.sendOutDialog.formData.expressNo = ''
    },
    async setByCompanyId(cmpIdx) {
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', cmpIdx)
      if (!companyCache) {
        return
      }
      this.sendOutDialog.formData.receiveCompany = companyCache.chineseName
      this.sendOutDialog.formData.receiveAddress = companyCache.address
      let company = { cmpIdx: cmpIdx }
      company = new Company(company)
      let contact = null
      if (company != null) {
        const contacts = await company.getContactsBycmpIdx()
        if (contacts) {
          for (const item of contacts) {
            if (item.defaultContact) {
              contact = item
              break
            }
          }
          if (contact) {
            this.sendOutDialog.formData.receivePerson = contact.contactPerson
            this.sendOutDialog.formData.receiveTel = contact.telephone
          }
        }
      }
    },
    // =============================送出 end==================================
    async successHandler() {
      this.toQueryByPage()
    },
    // 更新列表值
    backSuccessHandler(event) {
      if (event) {
        for (const file of event) {
          const index = this.businessList.rowData.findIndex(row => { return row.uuid === file.uuid })
          const rowData = this.businessList.rowData
          rowData[index] = file
          this.businessList.rowData = [...rowData]
        }
      }
      // 初始化选中业务
      this.businessList.selectedData = {}
      this.selectedFiles = []
      this.gridApi.clearFocusedCell()
      this.checkButtonState()
    },
    editRemarkHandler() {
      if (!this.businessList.selectedData || !this.businessList.selectedData.uuid) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.editDialog.visible = true
      this.editDialog.isRemarkOnly = true
      this.editDialog.bgdHp = false
      this.$refs.fileDialog.onShow('edit')
    },
    // 二次送出
    secondSendHandler() {
      if (!this.businessList.selectedData || !this.businessList.selectedData.uuid) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_ReDeliveryOrNot'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        type: 'warning'
      }).then(async() => {
        try {
          const file = this.businessList.selectedData
          if (!file.second && file.state !== 3) {
            const fileList = []
            const f = this.businessList.selectedData
            f.state = 1
            f.second = true
            f.secondSendDate = new Date()
            fileList.push(f)
            this.loading = getLoading()
            // 调用后端保存
            doSecondSendHandler(fileList).then(res => {
              this.backSuccessHandler(fileList)
            })
          }
        } finally {
          this.loading.close()
          await this.successHandler()
        }
      }).catch(() => {
        this.loading.close()
      })
    },
    // 删除文件
    deleteHandler() {
      if (!this.businessList.selectedData || !this.businessList.selectedData.uuid) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_DeleteOrNot'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        try {
          this.loading = getLoading()
          await delFile(this.businessList.selectedData.uuid)
        } finally {
          this.loading.close()
          await this.successHandler()
          this.$message.success(this.$t('common.tips.deleteSuccess'))
        }
      }).catch(() => {
        this.loading.close()
      })
    },
    // 批量取回
    onBack() {
      const rows = this.gridApi.getSelectedRows()
      if (rows === null || rows.length === 0) return
      this.takeBackDialog.visible = true
      this.takeBackDialog.dataLabel = this.$t('Message.GetBack') + this.$t('CargoMsg.Cargo_Date')
      this.takeBackDialog.dataLabelTitle = this.$t('SeaExport.Documents') + this.$t('Message.GetBack')
      this.takeBackDialog.dataField = 'sendDate'

      // 赋值 日期区间
      let minDate = null
      for (const file of rows) {
        if (!minDate) {
          minDate = file[this.takeBackDialog.dataField]
        } else if (file[this.takeBackDialog.dataField] && minDate.time > file[this.takeBackDialog.dataField].time) {
          minDate = file[this.takeBackDialog.dataField]
        }
      }
      this.takeBackDialog.startDate = minDate
      this.takeBackDialog.backDate = new Date()
      this.takeBackDialog.selectableRange = { 'rangeStart': minDate }
    },
    // 批量取消 取回
    onCancelBack() {
      const rows = this.gridApi.getSelectedRows()
      if (rows === null || rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoFileToRevoke'))
        return
      }
      let isCancelBack = false
      for (const file of rows) {
        if (file.state === 2) {
          isCancelBack = true
        }
      }
      if (!isCancelBack) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoFileToRevoke'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_SureToRevokeRetrieval'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        try {
          const fileList = []
          for (const file of rows) {
            file.state = 1
            file.backDate = null
            file.backUser = 0
            fileList.push(file)
          }
          // 调用后端保存
          batchBackFileHandler(fileList).then(res => {
            this.backSuccessHandler(fileList)
          })
        } finally {
          this.loading.close()
          this.$message.success(this.$t('CargoMsg.Cargo_RevokedSuccessfully'))
        }
      }).catch(() => {
        this.loading.close()
      })
    },
    onPrint() {
      this.selectedFiles = this.gridApi.getSelectedRows()
      if (this.selectedFiles.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      const params = {}
      params.FILE_UUID = Array.from(this.selectedFiles, p => p.uuid)
      if (this.job) {
        params.jobuuid = this.job.uuid
      }
      if (this.job.lob === 'SE') {
        this.templateSelectorDialog.cxt = new SeaExportJob(this.job)
      } else if (this.job.lob === 'AE') {
        this.templateSelectorDialog.cxt = new AirImportJob(this.job)
      } else if (this.job.lob === 'SI') {
        this.templateSelectorDialog.cxt = new SeaImportJob(this.job)
      } else if (this.job.lob === 'AE') {
        this.templateSelectorDialog.cxt = new AirExportJob(this.job)
      }
      this.templateSelectorDialog.category = 'FileList'
      this.templateSelectorDialog.data = params
      this.templateSelectorDialog.visible = true
    }
  }
}
</script>

<style lang="scss">
  #app #verify-tree-grid {
    .main-inner-row {
      display: flex;
      padding-top: 10px;
      padding-bottom: 10px;
    }
    .query-input-spacing {
      padding-right: 10px;
    }
  }
</style>
